/**
 * Promo Navigation Modal
 * Allows user to choose where to view a promo (Promo Spot or stay on Calendar)
 */
import React from 'react';
import ReactDOM from 'react-dom';

const PromoNavigationModal = ({ promo, onClose, onNavigateToPromoSpot }) => {
  if (!promo) return null;
  
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.98)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10020,
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        borderRadius: '20px',
        maxWidth: '500px',
        width: '100%',
        padding: '40px 30px',
        border: '2px solid rgba(255, 51, 102, 0.5)',
        position: 'relative',
        textAlign: 'center',
        boxShadow: '0 30px 80px rgba(0, 0, 0, 0.9)'
      }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          background: 'rgba(255,255,255,0.1)',
          border: 'none',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          color: 'white',
          cursor: 'pointer',
          fontSize: '18px',
          transition: 'all 0.3s'
        }}>×</button>
        
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>📢</div>
        <h2 style={{ color: 'white', marginBottom: '15px', fontSize: '24px', fontWeight: '700' }}>
          View This Promo
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '30px', lineHeight: '1.6' }}>
          {promo.title && <><strong style={{ color: 'white' }}>&quot;{promo.title}&quot;</strong><br /></>}
          Where would you like to view this promo?
        </p>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <button onClick={onNavigateToPromoSpot} style={{
            background: 'transparent',
            border: '2px solid #ff3366',
            borderRadius: '12px',
            padding: '16px 24px',
            color: '#ff3366',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 51, 102, 0.15)';
            e.currentTarget.style.borderColor = '#ff6699';
            e.currentTarget.style.color = '#ff6699';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.borderColor = '#ff3366';
            e.currentTarget.style.color = '#ff3366';
          }}>
            View on The Promo Spot
          </button>
          
          <button onClick={onClose} style={{
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '12px',
            padding: '16px 24px',
            color: 'white',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}>
            📅 Stay on Event Calendar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PromoNavigationModal;
